export default __webpack_public_path__ + "static/media/Icons_Close_currentColor.660094fa.svg";